export default function calcularTempoEmEspera(data_inicio) {
  // Backend salva horário de Brasília (UTC-3) como string sem timezone.
  // Sem o sufixo explícito, cada browser interpreta diferente — daí o -3h.
  // Forçar -03:00 garante parsing correto independente do browser/SO.
  const inicio = new Date(data_inicio.replace(" ", "T") + "-03:00");
  const agora = new Date();
  const diferenca = agora - inicio;

  // Guard: se diferença negativa (clock skew, etc), mostra 0
  if (diferenca < 0) return "0 minuto(s)";

  const minutos = Math.floor(diferenca / (1000 * 60));
  const horas = Math.floor(minutos / 60);
  const minutosRestantes = minutos % 60;

  if (horas > 0) {
    return `${horas} hora(s) e ${minutosRestantes} minuto(s)`;
  } else {
    return `${minutos} minuto(s)`;
  }
}